'use client';

import dynamic from 'next/dynamic';
import { useColors } from '@osmosis/tailwind-ui/helpers/useColors';
import { faBook } from '@fortawesome/pro-duotone-svg-icons/faBook';
import { useLearnData } from '../../../../context/LearnDataProvider';
import cksLogo from '../../../../public/images/cks_logo.png';
import Image from 'next/legacy/image';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { CommonLearnBlockProps } from '../LearnBlock';

const LearnBlock = dynamic(() => import('../LearnBlock'), { ssr: false });
const DigDeeperBlock = dynamic(() => import('./DigDeeperContent'));

/**
 * DigDeeper component.
 *
 * This component renders a "Dig Deeper" section if the `learnData` contains `cks` sections.
 * It uses the `useColors` hook to get the text color.
 * @returns {JSX.Element | null} The rendered component or null if no `cks` sections are present.
 */
export default function DigDeeper(props: CommonLearnBlockProps) {
  const { text } = useColors();

  const { learnData } = useLearnData();

  if (!learnData?.sections?.cks?.length) return null;

  return (
    <LearnBlock
      icon={faBook}
      iconStyles={{ color: text }}
      title="Dig Deeper"
      ImageComponent={<CKSLogoComponent />}
      content={<DigDeeperBlock cks={learnData.sections.cks} />}
      contentOnly={props.contentOnly}
    />
  );
}

function CKSLogoComponent(): JSX.Element {
  return (
    <Box className="left-[135px] top-[15px] scale-75 absolute">
      <Image alt="CKS Logo" src={cksLogo} />
    </Box>
  );
}
